import {html} from 'lit';
import Base from '../../base.js';
import '../../text/text-m.js';
import '../../icon/icon.js';
import styles from './button-fab-item.css' assert {type: 'css'};

/**
 * @element inv-button-fab
 *
 * @class ButtonFabItem
 * @classdesc This is a web component that creates a fab button item with an icon, href, label, target and rel properties.
 *
 * @property {string} icon - The icon name that the button should display
 * @property {string} href - The link that the button should point to
 * @property {string} color - The color of the button
 * @property {string} label - The label that the button should display
 * @property {string} target - The target of the button href
 * @property {string} rel - The rel attribute of the button href
 *
 * @cssproperty --inv-button-fab-background
 * @description The background gradient for the floating action button (FAB) in its normal state.
 * If not provided, defaults to a linear gradient with color stops as specified.
 * @type {string}
 * @default "linear-gradient(93.64deg, #00d5e0 1%, #15a6da 26.85%, #004bba 86.58%, #0f4595 99.6%)"
 *
 * @cssproperty --inv-button-fab-hover-background
 * @description The background color for the FAB in its hover state (if enabled).
 * If not provided, defaults to '#0e4dab'.
 * @type {string}
 * @default "#0e4dab"
 *
 * @cssproperty --inv-button-fab-item-icon-color
 * @description The color of the icon.
 * @type {string}
 * @default "#AABACA"
 */

export default class ButtonFabItem extends Base {
    static get properties() {
        return {
            icon: {
                type: String,
            },
            href: {
                type: String,
            },
            color: {
                type: String,
            },
            label: {
                type: String,
            },
            target: {
                type: String,
            },
            rel: {
                type: String,
            },
        };
    }

    constructor() {
        super();
        this.icon = '';
        this.href = '';
        this.label = null;
        this.target = '_self';
        this.target = 'noopener noreferrer';
    }

    getStyleSheets() {
        return [...super.getStyleSheets(), styles];
    }

    renderIconLabel() {
        return this.label
            ? html`
                  <div class="icon-label">
                      <a class="text-link" href="${this.href}" target="${this.target}" rel="${this.rel}">
                          <inv-text-m style="--inv-text-m-color:#fff; --inv-text-m-font-weight:600">
                              ${this.label}
                          </inv-text-m>
                      </a>
                  </div>
              `
            : null;
    }

    render() {
        return html`
            <div class="button-fab-item-container">
                ${this.renderIconLabel()}
                <div class="link-container">
                    <a class="icon-link" href="${this.href}" target="${this.target}" rel="${this.rel}">
                        <div class="icon-container">
                            <inv-icon
                                    width="1.8em"
                                    height="1.8em"
                                    color="var(--inv-button-fab-item-icon-color, #AABACA)"
                                    name="${this.icon}"
                            ></inv-icon>
                        </div>
                    </a>
                </div>
                </inv-icon>
            </div>`;
    }
}

ButtonFabItem.register();
